import React from 'react'
import { Link as RouterLink, useLocation } from 'react-router-dom'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import { TEXT } from '../../theme/tokens'

/**
 * Catch-all for paths no route matches.
 *
 * Without it an unknown or mistyped URL (or a stale bookmark from the old
 * x7k2m9 host) rendered the navigation shell around an empty page, which
 * reads as "the app is broken" rather than "wrong address".
 */
const NotFound = () => {
    const { pathname } = useLocation()
    return (
        <Box sx={{ py: 10, textAlign: 'center' }}>
            <Typography variant="overline" sx={{ color: TEXT.muted }}>
                404
            </Typography>
            <Typography variant="h5" sx={{ color: TEXT.primary, mb: 1 }}>
                Page not found
            </Typography>
            <Typography
                variant="body2"
                sx={{ color: TEXT.secondary, mb: 3, wordBreak: 'break-all' }}
            >
                Nothing lives at {pathname}.
            </Typography>
            <Button component={RouterLink} to="/" variant="contained">
                Go to Home
            </Button>
        </Box>
    )
}

export default NotFound
